import { Lab } from '../../types'

interface LabsState {
  currentLab: Lab
  currentLabSession: object | null
  focusedLabId: string
}

const state: LabsState = {
  currentLab: {},
  currentLabSession: null,
  focusedLabId: '',
}

export { LabsState, state }
